export const selectNotificationsList = (state) => state.notificationReducer.notificationsList;
export const selectUnreadNotifications = (state) => state.notificationReducer.unreadNotifications;
export const selectNotificationsLoading = (state) => state.notificationReducer.notificationLoader;
export const selectMarkAllLoading = (state) => state.notificationReducer.readAllLoading;
export const selectMarkSingleLoading = (state) => state.notificationReducer.readLoading;
export const selectLastPage = (state) => state.notificationReducer.isLastPage;
export const selectOptedOutNotifications = (state) => state.notificationReducer.optOutNotifications;
